import {action, observable} from 'mobx'
import {Table} from 'Store/_shared/table'

export class Tables {
  @observable selected = ''

  constructor(api) {
    this.transactions = new Table(api, 'paper-trading-session', 'transactions')
    this.positions = new Table(api, 'paper-trading-session', 'positions')
  }

  @action toggleSelected(table) {
    if (this.selected === table) {
      this.selected = ''
    } else {
      this.selected = table
    }
  }
}
